import React, { useEffect, useMemo, useState } from 'react';
import { createRoot } from 'react-dom/client';
import Slider from 'react-slick';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);
import ModalTherapy from './ModalTherapy';

const Terapias = () => {
    const [currentCat, setCurrentCategories] = useState(false);
    const [categories, setCategories] = useState([]);
    const [terapias, setTerapias] = useState([]);
    const [arrayDays, setArrayDays] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [currentTherapy, setCurrentTherapy] = useState({});
    const [room, setRoom] = useState({});
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // resize listener
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const settings = {
        slidesToShow: windowWidth > 1200 ? 3 : windowWidth > 768 ? 2 : 1,
        infinite: false,
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const resp = await fetch('/admin/api-rest/get-terapias');
                const data = await resp.json();

                if (data.days) {
                    setCategories(data.categories || []);
                    setTerapias(data.terapies || []);
                    setArrayDays(data.arrayDays || []);
                    setRoom(data.room || {});
                }
            } catch (e) {
                console.log(e);
            }
        };

        getData();
    }, []);

    const showTerapias = useMemo(() => {
        if (currentCat && terapias) {
            return terapias.filter((t) => t.therapy_category_id == currentCat);
        }
        return terapias || [];
    }, [currentCat, terapias]);

    const handleCat = (e, id) => {
        e.preventDefault();
        setCurrentCategories(id);
    };

    const handleOpenReservacion = (e, therapy) => {
        e.preventDefault();
        setCurrentTherapy(therapy);
        setModalIsOpen(true);
    };

    return (
        <>
            <div className="text-center col-12">
                <div className="nav-terapias">
                    <ul>
                        <li className={`${!currentCat ? 'active' : ''}`}>
                            <a href="#" onClick={(e) => handleCat(e, null)}>Todas</a>
                        </li>
                        {categories && categories.map((c) => (
                            <li
                                key={`cat-${c.id}`}
                                className={`${c.id == currentCat ? 'active' : ''}`}
                            >
                                <a href="#" onClick={(e) => handleCat(e, c.id)}>{c.name}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="col-12 bg-gray">
                <Slider {...settings} className="slider">
                    {showTerapias && showTerapias.map((t) => {
                        // descripción segura
                        const desc = (t.description || '').toString();
                        const shortDesc = desc.length > 0
                            ? `${desc.substring(0, 100)}..`
                            : 'Sin descripción';

                        const hasImage = Array.isArray(t.images) && t.images.length > 0 && t.images[0];

                        return (
                            <div key={`terapy-${t.id}`} className="single-therapy">
                                <figure>
                                    {hasImage && (
                                        <img
                                            src={`/uploads/${t.images[0].image}`}
                                            className="img-fluid"
                                            alt={t.name}
                                        />
                                    )}
                                </figure>
                                <div className="content-therapy">
                                    <h2>{t.name}</h2>
                                    <p>{shortDesc}</p>
                                    <div className="buttons">
                                        <a
                                            href={`/admin/paciente-panel/terapias/${t.id}`}
                                            className="btn1"
                                        >
                                            Ver Más
                                        </a>
                                        <a
                                            href="#"
                                            onClick={(e) => handleOpenReservacion(e, t)}
                                            className="btn2"
                                        >
                                            Solicitar
                                        </a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </Slider>
            </div>

            <ModalTherapy
                currentTherapy={currentTherapy}
                arrayDays={arrayDays}
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setModalIsOpen}
                room={room}
                el="catalog-therapies"
            />
        </>
    );
};

// Montar en React 18
const terapiasEl = document.getElementById('terapias');
if (terapiasEl) {
    const root = createRoot(terapiasEl);
    root.render(<Terapias />);
}
